import {tns} from 'tiny-slider/src/tiny-slider';

window.tns = tns;

function init(){
    let reviewsSliderElement = document.getElementById('reviews-slider')
    if(reviewsSliderElement){
        tns({
            container: reviewsSliderElement,
            items: 1,
            touch: true,
            mouseDrag: true,
            slideBy: 'page',
            autoHeight: true,
            autoplay: false,
            nav: false,
            loop: true,
            speed: 250
        });
    }
}

if (window.addEventListener) {
    window.addEventListener('load', init, false);
} else if (window.attachEvent) {
    window.attachEvent('onload', init);
}